.root {
  overflow: auto;
}

.stepper {
  padding: 0;
  padding-left: 4px;
  background-color: inherit;
}

.stepConnector {
  min-height: 8px;
}

.highlight {
  border-color: var(--tuna-palette-success-light);
  border-style: dashed;
  border-width: 2px;
}

.labelContent {
  display: flex;
  flex-direction: column;
}

.stepContent {
  font-size: 12px;
}
